import { PROPAGATION_STATUS } from '@/enums/domains/domains.enum';
import { DomainsActionTypes } from './domains.types';

export const initialState = {
  list: [],
  listTotal: 0,
  loading: false,
  loaded: false,
  detail: {
    id: '',
    loading: false,
    loadingRenewal: false,
    domain: '',
    registrationDate: '',
    firstPaymentAmount: '',
    paymentMethod: '',
    recurringAmount: '',
    registrar: '',
    registrationPeriod: 1,
    billingCycle: '',
    expiryDate: '',
    nextInvoiceDate: '',
    status: '',
    doNotRenew: 0,
    nextDueDate: '',
    actions: [],
  },
  domains: {
    generateNewInvoice: {
      loading: false,
    },
  },
  propagationStatus: [],
  domainsElegible: [],
  domainConfiguredStatus: {
    id: 0,
    domain: '',
    status: '',
    loaded: false,
  },
  eppKey: {
    activeDomainsList: [],
    modalIsOpen: false,
    domainId: 0,
    domainName: '',
    keyGenerated: null,
    redirect: false,
  },
  changeDomain: {
    loading: false,
    lastAttempt: null,
    newDomain: null,
  },
  temporaryDomains: [],
  temporaryDomainsLoaded: false,
  loadingTempDomainCreation: false,
  domainRedeem: {
    loading: false,
    status: null,
  },
  domainTlds: {
    loading: false,
    data: null,
    products: [],
    status: null,
  },
  domainAvailability: {
    loading: false,
    status: null,
    currentDomain: {
      domain: null,
      isAvailable: false,
      availableTlds: [],
    },
    currentRadix: {
      domain: null,
      isAvailable: false,
      availableTlds: [],
    },
  },
  checkProvider: {
    loading: false,
    status: null,
    available: false,
  },
  redeemAvailability: {
    loaded: false,
    domains: [],
  },
  buyDomain: {
    search: {
      loading: false,
      status: null,
      result: [],
    },
    loading: false,
  },
};

const domainsReducer = (state = initialState, action) => {
  let newList = [];
  switch (action.type) {
    case DomainsActionTypes.LOADING_BUY_DOMAIN: {
      return {
        ...state,
        buyDomain: {
          ...state.buyDomain,
          loading: action.payload,
        },
      };
    }
    case DomainsActionTypes.SET_CREATE_TEMPORARY_DOMAIN_LOADING_STATUS: {
      return {
        ...state,
        loadingTempDomainCreation: action.payload,
      };
    }
    case DomainsActionTypes.SET_TEMPORARY_DOMAIN_CREATED: {
      return {
        ...state,
        createdTemporaryDomain: action.payload.domain,
      };
    }
    case DomainsActionTypes.SET_DOMAINS_REDEEM_AVAILABILITY: {
      return {
        ...state,
        redeemAvailability: {
          ...state.redeemAvailability,
          domains: [...action.payload],
        },
      };
    }

    case DomainsActionTypes.GET_DOMAINS_REDEEM_AVAILABILITY_SUCCESS:
    case DomainsActionTypes.GET_DOMAINS_REDEEM_AVAILABILITY_FAILURE: {
      return {
        ...state,
        redeemAvailability: {
          ...state.redeemAvailability,
          loaded: true,
        },
      };
    }

    case DomainsActionTypes.RESET_DOMAINS_REDEEM_AVAILABILITY: {
      return {
        ...state,
        redeemAvailability: {
          ...initialState.redeemAvailability,
        },
      };
    }

    case DomainsActionTypes.SET_TEMPORARY_DOMAINS_LIST: {
      return {
        ...state,
        temporaryDomains: action.payload,
        temporaryDomainsLoaded: true,
      };
    }
    case DomainsActionTypes.LOADING_CHANGE_DOMAIN: {
      return {
        ...state,
        changeDomain: {
          ...state.changeDomain,
          loading: action.payload,
          lastAttempt: null,
        },
      };
    }
    case DomainsActionTypes.SUCCESS_CHANGE_DOMAIN: {
      return {
        ...state,
        changeDomain: {
          ...state.changeDomain,
          lastAttempt: 'success',
        },
      };
    }
    case DomainsActionTypes.SET_NEW_DOMAIN: {
      const { domain } = action.payload;

      return {
        ...state,
        changeDomain: {
          ...state.changeDomain,
          newDomain: domain,
        },
      };
    }
    case DomainsActionTypes.RESET_CHANGE_DOMAIN_STATE: {
      return {
        ...state,
        changeDomain: {
          ...state.changeDomain,
          newDomain: null,
          lastAttempt: null,
          loading: false,
        },
      };
    }
    case DomainsActionTypes.FAILURE_CHANGE_DOMAIN: {
      return {
        ...state,
        changeDomain: {
          ...state.changeDomain,
          lastAttempt: action.payload,
        },
      };
    }
    case DomainsActionTypes.SET_DOMAINS: {
      newList = [];

      if (action.payload.page && action.payload.page > 1) {
        newList.push(...state.list);
      }

      if (action.payload.domains) {
        newList.push(...action.payload.domains);
      }
      if (action.payload.length) {
        newList.push(...action.payload);
      }

      return {
        ...state,
        list: newList,
        listTotal: action.payload.total,
        loading: false,
        loaded: true,
      };
    }
    case DomainsActionTypes.GET_DOMAINS_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    }
    case DomainsActionTypes.GET_DOMAINS_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case DomainsActionTypes.GET_DOMAINS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case DomainsActionTypes.SET_DOMAIN_DETAIL: {
      return {
        ...state,
        detail: {
          ...action.payload,
          loading: false,
        },
      };
    }
    case DomainsActionTypes.GET_DOMAIN_DETAIL_FAILURE:
    case DomainsActionTypes.GET_DOMAIN_DETAIL_SUCCESS: {
      return {
        ...state,
        detail: {
          ...initialState.detail,
          loading: false,
        },
      };
    }
    case DomainsActionTypes.GET_DOMAIN_DETAIL_REQUEST: {
      return {
        ...state,
        detail: {
          ...initialState.detail,
          loading: true,
        },
      };
    }
    case DomainsActionTypes.SET_DOMAIN_PROPAGATION_STATUS: {
      const allStatus = action.payload;
      return {
        ...state,
        propagationStatus: allStatus,
      };
    }
    case DomainsActionTypes.SET_CONFIGURED_DOMAIN_STATUS: {
      const { id, domain, status } = action.payload;
      return {
        ...state,
        domainConfiguredStatus: {
          ...state.domainConfiguredStatus,
          id,
          domain,
          status,
        },
      };
    }
    case DomainsActionTypes.SET_EMPTY_DOMAIN_STATUS: {
      return {
        ...state,
        domainConfiguredStatus: {
          ...state.domainConfiguredStatus,
          status: PROPAGATION_STATUS.OUT_OF_RANGE,
          loaded: true,
        },
      };
    }
    case DomainsActionTypes.SET_RESET_DOMAIN_STATUS: {
      return {
        ...state,
        domainConfiguredStatus: {
          ...initialState.domainConfiguredStatus,
        },
      };
    }
    case DomainsActionTypes.SET_LOADED_CONFIGURED_DOMAIN_STATUS: {
      return {
        ...state,
        domainConfiguredStatus: {
          ...state.domainConfiguredStatus,
          loaded: true,
        },
      };
    }
    case DomainsActionTypes.DOMAIN_GENERATE_NEW_INVOICE_LOADING: {
      return {
        ...state,
        domains: {
          ...state.domains,
          generateNewInvoice: {
            ...state.domains.generateNewInvoice,
            loading: action.value,
          },
        },
      };
    }
    case DomainsActionTypes.SET_DOMAIN_EPP_REDIRECT: {
      return {
        ...state,
        eppKey: {
          ...state.eppKey,
          redirect: action.payload,
        },
      };
    }
    case DomainsActionTypes.SET_MODAL_EPP_KEY_IS_OPEN: {
      return {
        ...state,
        eppKey: {
          ...state.eppKey,
          modalIsOpen: true,
          domainId: action.payload.id,
          domainName: action.payload.name,
        },
      };
    }
    case DomainsActionTypes.SET_MODAL_EPP_KEY_IS_CLOSED: {
      return {
        ...state,
        eppKey: {
          ...initialState.eppKey,
        },
      };
    }
    case DomainsActionTypes.SET_MODAL_EPP_KEY_IS_CHANGED: {
      return {
        ...state,
        eppKey: {
          ...state.eppKey,
          domainId: action.payload.id,
          domainName: action.payload.name,
        },
      };
    }
    case DomainsActionTypes.SET_EPP_KEY_GENERATED: {
      return {
        ...state,
        eppKey: {
          ...state.eppKey,
          keyGenerated: action.payload,
        },
      };
    }
    case DomainsActionTypes.SET_ALL_DOMAINS_LIST: {
      return {
        ...state,
        eppKey: {
          ...state.eppKey,
          activeDomainsList: action.payload,
        },
      };
    }
    case DomainsActionTypes.SET_DOMAINS_ELEGIBLE: {
      return {
        ...state,
        domainsElegible: action.payload.data,
      };
    }
    case DomainsActionTypes.LOADING_REDEEM_DOMAIN: {
      return {
        ...state,
        domainRedeem: {
          ...state.domainRedeem,
          loading: action.payload,
        },
      };
    }
    case DomainsActionTypes.RESET_REDEEM_DOMAIN: {
      return {
        ...state,
        domainRedeem: {
          ...initialState.domainRedeem,
        },
      };
    }
    case DomainsActionTypes.SUCCESS_REDEEM_DOMAIN: {
      return {
        ...state,
        domainRedeem: {
          ...state.domainRedeem,
          status: 'success',
        },
      };
    }
    case DomainsActionTypes.FAILURE_REDEEM_DOMAIN: {
      return {
        ...state,
        domainRedeem: {
          ...state.domainRedeem,
          status: 'failure',
        },
      };
    }
    case DomainsActionTypes.SET_AVAILABLE_DOMAIN_TLDS: {
      const { tldsResponse } = action.payload;

      return {
        ...state,
        domainTlds: {
          ...state.domainTlds,
          data: tldsResponse.tld,
          products: tldsResponse.products,
        },
      };
    }
    case DomainsActionTypes.SET_AVAILABLE_DOMAIN_TLDS_LOADING: {
      return {
        ...state,
        domainTlds: {
          ...state.domainTlds,
          loading: action.payload,
        },
      };
    }
    case DomainsActionTypes.AVAILABLE_DOMAIN_TLDS_SUCCESS: {
      return {
        ...state,
        domainTlds: {
          ...state.domainTlds,
          status: 'success',
        },
      };
    }
    case DomainsActionTypes.AVAILABLE_DOMAIN_TLDS_FAILURE: {
      return {
        ...state,
        domainTlds: {
          ...state.domainTlds,
          status: 'failure',
        },
      };
    }
    case DomainsActionTypes.SET_DOMAIN_AVAILABILITY: {
      const {
        isAvailable, currentDomain, tldsList, isRadix,
      } = action.payload;

      if (isRadix) {
        return {
          ...state,
          domainAvailability: {
            ...state.domainAvailability,
            currentRadix: {
              ...state.domainAvailability.currentRadix,
              domain: currentDomain,
              isAvailable,
            },
          },
        };
      }

      return {
        ...state,
        domainAvailability: {
          ...state.domainAvailability,
          currentDomain: {
            ...state.domainAvailability.currentDomain,
            domain: currentDomain,
            isAvailable,
            availableTlds: tldsList,
          },
        },
      };
    }
    case DomainsActionTypes.RESET_CURRENT_RADIX_DOMAIN_AVAILABILITY: {
      return {
        ...state,
        domainAvailability: {
          ...state.domainAvailability,
          currentRadix: {
            ...initialState.domainAvailability.currentRadix,
          },
        },
      };
    }
    case DomainsActionTypes.LOADING_DOMAIN_AVAILABILITY: {
      return {
        ...state,
        domainAvailability: {
          ...state.domainAvailability,
          loading: action.payload,
        },
      };
    }
    case DomainsActionTypes.DOMAIN_AVAILABILITY_SUCCESS: {
      return {
        ...state,
        domainAvailability: {
          ...state.domainAvailability,
          status: 'success',
        },
      };
    }
    case DomainsActionTypes.DOMAIN_AVAILABILITY_FAILURE: {
      return {
        ...state,
        domainAvailability: {
          ...state.domainAvailability,
          status: 'failure',
        },
      };
    }
    case DomainsActionTypes.RESET_DOMAIN_AVAILABILITY: {
      return {
        ...state,
        domainAvailability: {
          ...initialState.domainAvailability,
        },
      };
    }
    case DomainsActionTypes.SET_CHECK_PROVIDER_LOADING: {
      return {
        ...state,
        checkProvider: {
          ...state.checkProvider,
          loading: action.payload,
        },
      };
    }
    case DomainsActionTypes.CHECK_PROVIDER_SUCCESS: {
      return {
        ...state,
        checkProvider: {
          ...state.checkProvider,
          status: 'success',
        },
      };
    }
    case DomainsActionTypes.CHECK_PROVIDER_FAILURE: {
      return {
        ...state,
        checkProvider: {
          ...state.checkProvider,
          status: 'failure',
        },
      };
    }
    case DomainsActionTypes.SET_CHECK_PROVIDER: {
      const { available } = action.payload;

      return {
        ...state,
        checkProvider: {
          ...state.checkProvider,
          available,
        },
      };
    }
    case DomainsActionTypes.RESET_CHECK_PROVIDER: {
      return {
        ...state,
        checkProvider: {
          ...initialState.checkProvider,
        },
      };
    }
    case DomainsActionTypes.GET_DOMAINS_TO_BUY_SUCCESS: {
      return {
        ...state,
        buyDomain: {
          ...state.buyDomain,
          search: {
            ...state.buyDomain.search,
            result: action.payload.result,
            status: 'success',
          },
        },
      };
    }
    case DomainsActionTypes.GET_DOMAINS_TO_BUY_LOADING: {
      return {
        ...state,
        buyDomain: {
          ...state.buyDomain,
          search: {
            ...state.buyDomain.search,
            loading: action.payload,
          },
        },
      };
    }

    default: {
      return state;
    }
  }
};

export default domainsReducer;
